"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPagePasswordReset = void 0;
const auth_1 = require("firebase/auth");
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_router_dom_1 = require("react-router-dom");
const authContext_1 = require("../../context/authContext");
const validationUtils = __importStar(require("../../utils/validationUtils"));
const ValidationErrors_1 = require("../ValidationErrors");
class ValidationErrorsPasswordReset extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.emailWrongFormat = "";
        this.emailInvalid = "";
    }
}
const ManagerPagePasswordReset = (props) => {
    const [email, setEmail] = (0, react_1.useState)("");
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(validate(email));
    const [isResetEmailSent, setIsResetEmailSent] = (0, react_1.useState)(false);
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    function handleEmailChange(newEmail) {
        setEmail(newEmail);
        setValidationErrors(validate(newEmail));
    }
    async function handleSignin(e) {
        e.preventDefault();
        if (!showErrors) {
            // User clicked button. Show validation on next render.
            setShowErrors(true);
        }
        if (!validationErrors.hasErrors()) {
            try {
                await (0, auth_1.sendPasswordResetEmail)(auth, email);
                // E-Mail was sent.
                setIsResetEmailSent(true);
            }
            catch (error) {
                const newValidationErrors = new ValidationErrorsPasswordReset();
                switch (error.code) {
                    case "auth/user-not-found":
                        newValidationErrors.emailInvalid =
                            "Kein Benutzer mit dieser E-Mail gefunden.";
                        break;
                    case "auth/too-many-requests":
                        newValidationErrors.emailInvalid =
                            "Zu viele Loginversuche. Bitte später nochmals versuchen.";
                        break;
                    default:
                        newValidationErrors.emailInvalid = "E-Mail ist ungültig.";
                }
                setValidationErrors(newValidationErrors);
            }
        }
    }
    return (react_1.default.createElement(Container_1.default, null,
        react_1.default.createElement(Row_1.default, { className: "mt-5" },
            react_1.default.createElement(Col_1.default, { sm: { span: 10, offset: 1 }, md: { span: 6, offset: 3 } },
                react_1.default.createElement(Card_1.default, null,
                    react_1.default.createElement(Card_1.default.Header, { as: "h4" }, "Neues Passwort setzen"),
                    react_1.default.createElement(Card_1.default.Body, null,
                        react_1.default.createElement(Form_1.default, { noValidate: true, onSubmit: handleSignin },
                            react_1.default.createElement(Form_1.default.Group, { controlId: "email" },
                                react_1.default.createElement(Form_1.default.Label, null, "E-Mail"),
                                react_1.default.createElement(Form_1.default.Control, { type: "email", value: email, onChange: (e) => handleEmailChange(e.target.value), isInvalid: showErrors && validationErrors.emailWrongFormat !== "" }),
                                react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.emailWrongFormat)),
                            validationErrors.emailInvalid !== "" && (react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "danger" }, validationErrors.emailInvalid)),
                            isResetEmailSent && (react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "success" }, "Ein Link zum Setzen des Passwortes wurde per E-Mail verschickt.")),
                            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                !isResetEmailSent && (react_1.default.createElement(Button_1.default, { variant: "primary", type: "submit", disabled: showErrors && validationErrors.hasErrors() }, "Link f\u00FCr Passwort zusenden")),
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/signin/` }, "zum Login")))))))));
};
exports.ManagerPagePasswordReset = ManagerPagePasswordReset;
function validate(email) {
    const errors = new ValidationErrorsPasswordReset();
    if (!validationUtils.validEmail(email)) {
        errors.emailWrongFormat = "Bitte gültige E-Mail Adresse angeben.";
    }
    return errors;
}
